import React__default from 'react';
import { C as ChannelListProvider } from './ChannelListProvider-e9a09891.js';
import ChannelListUI from './ChannelList/components/ChannelListUI.js';
import './_rollupPluginBabelHelpers-05128ded.js';
import '@sendbird/chat/groupChannel';
import './topics-eb548880.js';
import './uuid-717930b4.js';
import './utils-e0c7329c.js';
import './UserProfileContext-f3f446d2.js';
import 'prop-types';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './index-579ca9d7.js';
import './utils/message/getOutgoingMessageState.js';
import './ChannelList/components/ChannelListHeader.js';
import './LocalizationContext-a82461b5.js';
import './stringSet-b60e9529.js';
import './index-6add7940.js';
import './index-6420013c.js';
import './ui/Avatar.js';
import './ui/ImageRenderer.js';
import './ui/Icon.js';
import './ChannelList/components/AddChannel.js';
import './ui/IconButton.js';
import './CreateChannel.js';
import './CreateChannel/components/CreateChannelUI.js';
import './CreateChannelProvider-47a1c523.js';
import './sendbirdSelectors.js';
import './CreateChannel/components/InviteUsers.js';
import './ui/Modal.js';
import 'react-dom';
import './index-a9101009.js';
import './ui/Button.js';
import './MediaQueryContext-d6110905.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './ui/ContextMenu.js';
import './ui/SortByRow.js';
import './CreateChannel/components/SelectChannelType.js';
import './ChannelList/components/ChannelPreview.js';
import './ui/ChannelAvatar.js';
import './utils-7f5e872b.js';
import './ui/Badge.js';
import './index-ac0b2d20.js';
import './index-ccef08fe.js';
import './ui/Loader.js';
import './index-f879f6ef.js';
import './index-ad50e2c0.js';
import './ui/MentionUserLabel.js';
import './consts-b4cb83cf.js';
import './ui/TextButton.js';
import './color-91e43dce.js';
import './Channel/components/TypingIndicator.js';
import './ChannelProvider-5dcbee7b.js';
import './const-72f012b6.js';
import './compareIds-2e50e905.js';
import '@sendbird/chat/message';
import './consts-fa6ab3c0.js';
import './resolvedReplyType-9d00a3db.js';
import './useLongPress-12280c78.js';
import './ChannelList/components/ChannelPreviewAction.js';
import './EditUserProfile.js';
import './index-10dad19d.js';
import './ui/Input.js';
import './actionTypes-ba87a2c9.js';
import './index-2cfab646.js';
var ChannelList = function ChannelList(props) {
  return /*#__PURE__*/React__default.createElement(ChannelListProvider, {
    className: props === null || props === void 0 ? void 0 : props.className,
    disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile,
    allowProfileEdit: props === null || props === void 0 ? void 0 : props.allowProfileEdit,
    onBeforeCreateChannel: props === null || props === void 0 ? void 0 : props.onBeforeCreateChannel,
    onThemeChange: props === null || props === void 0 ? void 0 : props.onThemeChange,
    overrideInviteUser: props === null || props === void 0 ? void 0 : props.overrideInviteUser,
    onProfileEditSuccess: props === null || props === void 0 ? void 0 : props.onProfileEditSuccess,
    onChannelSelect: props === null || props === void 0 ? void 0 : props.onChannelSelect,
    sortChannelList: props === null || props === void 0 ? void 0 : props.sortChannelList,
    queries: props === null || props === void 0 ? void 0 : props.queries,
    disableAutoSelect: props === null || props === void 0 ? void 0 : props.disableAutoSelect,
    activeChannelUrl: props === null || props === void 0 ? void 0 : props.activeChannelUrl,
    isTypingIndicatorEnabled: props === null || props === void 0 ? void 0 : props.isTypingIndicatorEnabled,
    isMessageReceiptStatusEnabled: props === null || props === void 0 ? void 0 : props.isMessageReceiptStatusEnabled
  }, /*#__PURE__*/React__default.createElement(ChannelListUI, {
    renderChannelPreview: props === null || props === void 0 ? void 0 : props.renderChannelPreview,
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile,
    renderHeader: props === null || props === void 0 ? void 0 : props.renderHeader,
    renderPlaceHolderEmptyList: props === null || props === void 0 ? void 0 : props.renderPlaceHolderEmptyList,
    renderPlaceHolderError: props === null || props === void 0 ? void 0 : props.renderPlaceHolderError,
    renderPlaceHolderLoading: props === null || props === void 0 ? void 0 : props.renderPlaceHolderLoading
  }));
};
export { ChannelList as default };